export enum Role {
    ACCOUNT = "MY_ACCOUNT",
    CAMPAIGN = "MY_CAMPAIGN",
    FLEET = "MY_FLEET",
    INSPECTIONS = "MY_INSPECTIONS",
    NETWORK = "MY_NETWORK",
    RECORDS = "MY_RECORDS",
    STATISTICS = "MY_STATISTICS",
    TEMPLATES = "MY_TEMPLATES",
}